import { render, staticRenderFns } from "./RegistroViajeros.vue?vue&type=template&id=def57a1a&scoped=true"
import script from "./RegistroViajeros.vue?vue&type=script&lang=js"
export * from "./RegistroViajeros.vue?vue&type=script&lang=js"
import style0 from "./RegistroViajeros.vue?vue&type=style&index=0&id=def57a1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "def57a1a",
  null
  
)

export default component.exports